import React from "react";
import { UpdateBanner } from "common/components";
import { useVersionCheck } from "hooks/useVersionCheck";

/**
 * Wires the `/version.json` poll to the reload prompt.
 *
 * <p>Mounted outside `<App/>` (in index.tsx) on purpose: a deploy can land while the user is
 * sitting on the login surface or on an error screen, and those paths return early from
 * `App`. Keeping the prompt at the root means "a new build exists" is reported from any state
 * the app can be in.
 */
export const AppUpdatePrompt: React.FC = () => {
  const { updateAvailable, latestVersion, reload, dismiss } = useVersionCheck();

  return (
    <UpdateBanner
      show={updateAvailable}
      latestVersion={latestVersion}
      onReload={reload}
      onDismiss={dismiss}
    />
  );
};
